import React, { SVGProps } from 'react';

export const IconSleepMode = (props: SVGProps<SVGSVGElement>) => <svg fill="none" viewBox="0 0 32 32" width="1em" height="1em" {...props}><path fill="currentColor" fillRule="evenodd" d="M25.03 20.31c.19-.4-.24-.8-.66-.67A8 8 0 0 1 16.19 6.5c.18-.19.06-.5-.19-.5a10 10 0 1 0 9.03 14.31Z" clipRule="evenodd"/></svg>;
